import { gql } from '@/__generated__';

export const customerDocument = gql(/* GraphQL */ `
  query Customer($where: CustomerWhereUniqueInput!) {
    customer(where: $where) {
      id
      pageId
      name
      email
      avatar
      createdAt
      updatedAt
      _count {
        orders
        messages
        addresses
      }
      messages(orderBy: [{ createdAt: desc }], take: 100) {
        id
        body
        isEcho
        createdAt
        customer {
          id
          name
          avatar
        }
      }
    }
  }
`);
